import { Component } from 'react';
import PropTypes from 'prop-types';

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}; //      


var MakeAsyncFunction = function (_React$Component) {
  inherits(MakeAsyncFunction, _React$Component);

  function MakeAsyncFunction(props) {
    classCallCheck(this, MakeAsyncFunction);

    var _this = possibleConstructorReturn(this, (MakeAsyncFunction.__proto__ || Object.getPrototypeOf(MakeAsyncFunction)).call(this, props));

    _initialiseProps.call(_this);

    if (process.env.NODE_ENV !== 'production' && typeof props.children !== 'function') {
      console.error('Warning: Must provide a render function as children');
    }

    var listener = props.listener,
        start = props.start,
        resolve = props.resolve,
        reject = props.reject,
        setPayload = props.setPayload,
        getPayload = props.getPayload,
        getError = props.getError;
    _this.state = {
      asyncFunction: listener.createAsyncFunction({
        start: start,
        resolve: resolve,
        reject: reject,
        setPayload: setPayload,
        getPayload: getPayload,
        getError: getError
      })
    };
    return _this;
  }

  createClass(MakeAsyncFunction, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createAsyncFunction();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.start !== this.props.start || prevProps.resolve !== this.props.resolve || prevProps.reject !== this.props.reject) {
        this.createAsyncFunction();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children && this.state.asyncFunction ? this.props.children(this.state.asyncFunction.asyncFunction) : null;
    }
  }]);
  return MakeAsyncFunction;
}(Component);

MakeAsyncFunction.propTypes = {
  children: PropTypes.func.isRequired,
  listener: PropTypes.object.isRequired,
  start: PropTypes.string.isRequired,
  resolve: PropTypes.string.isRequired,
  reject: PropTypes.string.isRequired,
  setPayload: PropTypes.func,
  getPayload: PropTypes.func,
  getError: PropTypes.func
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.unsubscribe = function () {
    if (_this2.state.asyncFunction) {
      _this2.state.asyncFunction.unsubscribe();
    }
  };

  this.createAsyncFunction = function () {
    var _props = _this2.props,
        listener = _props.listener,
        start = _props.start,
        resolve = _props.resolve,
        reject = _props.reject,
        setPayload = _props.setPayload,
        getPayload = _props.getPayload,
        getError = _props.getError;

    _this2.unsubscribe();

    _this2.setState({
      asyncFunction: listener.createAsyncFunction({
        start: start,
        resolve: resolve,
        reject: reject,
        setPayload: setPayload,
        getPayload: getPayload,
        getError: getError
      })
    });
  };
}; //


export default MakeAsyncFunction;